module.exports = __webpack_public_path__ + "img/droplet-degree.1dec7fe4.svg";